import { Route, Routes } from "react-router-dom";
import { memo } from "react";
import ExploreCategoryPage from "../screens/Explore/ExploreCategoryPage";
import ExplorePage from "../screens/Explore/ExplorePage";

const ExploreRoute = memo(function ExploreRouteFn() {
  return (
    <Routes>
      <Route index element={<ExplorePage />} />
      <Route path=":categoryName" element={<ExploreCategoryPage />} />
    </Routes>
  );
});

export default ExploreRoute;
